import HeroSection from '../../../components/HeroSection';
import { PageWrapper } from '../../../components/Layouts/PageWrapper';
import AccordionList from '../../../ui/accordion';
import {
  HERO,
  EXPECTATIONS,
  HOW_WE_WORK,
  WHY_CHOOSE,
  COMMON_QUESTIONS,
  ALREADY_CLIENT,
  BOOK_FREE_CONSULTATION,
} from './constants';
import BenefitsOverview from '../../../components/BenefitsOverview';
import HowWeWork from './components/HowWeWork';
import WhyChoose from './components/WhyChoose';
import AlreadyClient from './components/AlreadyClient';
import BookFreeConsultation from './components/BookFreeConsultation';
import { useNavigate } from 'react-router-dom';
import { openSimplePracticeConsultation } from '../../../utils/simplePractice';

const YourJourney = () => {
  const navigate = useNavigate();
  const handleBookConsultation = () => {
    openSimplePracticeConsultation();
  };
  const handleLearnMoreServices = () => {
    navigate('/services');
  };
  return (
    <PageWrapper>
      <HeroSection {...HERO} onContainedButtonClick={handleBookConsultation} />
      <BenefitsOverview {...EXPECTATIONS} onButtonClick={handleLearnMoreServices} />
      <HowWeWork {...HOW_WE_WORK} onButtonClick={handleBookConsultation} />
      <WhyChoose {...WHY_CHOOSE} />
      <AccordionList {...COMMON_QUESTIONS} onButtonClick={handleLearnMoreServices} />
      <AlreadyClient {...ALREADY_CLIENT} />
      <BookFreeConsultation {...BOOK_FREE_CONSULTATION} />
    </PageWrapper>
  );
};

export default YourJourney;
